var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1C1C1C","fillRule":"nonzero","d":"M12.137.005L9.112 0C5.713 0 3.517 2.318 3.517 5.906V8.63H.476A.483.483 0 0 0 0 9.12v3.945c0 .27.213.49.476.49h3.041v9.956c0 .27.213.489.476.489H7.96c.263 0 .476-.22.476-.49v-9.956h3.556a.482.482 0 0 0 .476-.489l.001-3.946c0-.13-.05-.254-.14-.346a.47.47 0 0 0-.336-.143H8.437V6.32c0-1.11.257-1.673 1.662-1.673h2.038c.262 0 .475-.22.475-.49V.494a.483.483 0 0 0-.475-.489z"}));
}

Facebook.defaultProps = {"width":"13","height":"24","viewBox":"0 0 13 24"};

module.exports = Facebook;

Facebook.default = Facebook;
